import { NestedQuota } from '../../../shared/interfaces/quota.interface';
import { RandomStringGenerator } from '../../../shared/utils/random-string-generator';
import { IndividualQuotaBuilder } from './individual-quota-builder';
import { NestingQualification } from '../../../shared/interfaces/quota-nesting.interface';
import { NestedQuotaGroupCriteriaBuilder } from './nested-quota-group-criteria-builder';
import { IncrementalTitleGenerator } from '../../../shared/utils/incremental-title-generator';
import { DEFAULT } from '../../../shared/constants/defaults';

interface QuotaGroupBuild {
  build(): NestedQuota;
}

export class NestedQuotaGroupBuilder implements QuotaGroupBuild {
  constructor(
    private readonly _selectedNestedQuotas: NestedQuota[],
    private readonly _selectedQualifications: NestingQualification[],
    private readonly _existingTitles: string[],
    private readonly _groupId: string = DEFAULT.NESTED_GROUP_KEY
  ) {}

  public build(): NestedQuota {
    return {
      buyer_quota_id: new RandomStringGenerator().generate(),
      group_key: this._groupId,
      required_count: this._count(),
      number: this._count(),
      minimum: this._minimum(),
      maximum: this._maximum(),
      fielded: this._fileded(),
      percentage: this._percentage(),
      flexiblePer: this._flexibilityPercentage(),
      quota_title: this._quotaTitle(),
      isQuotaGrouped: true,
      isChecked: false,
      criteria: new NestedQuotaGroupCriteriaBuilder(
        this._selectedNestedQuotas
      ).build(),
      individual_quotas: new IndividualQuotaBuilder(
        this._selectedNestedQuotas,
        this._selectedQualifications
      ).build(),
    };
  }

  private _count(): number {
    return this._selectedNestedQuotas.reduce(
      (total, selected) =>
        total + (selected.required_count || selected.number || 0),
      0
    );
  }

  private _minimum(): number {
    return this._selectedNestedQuotas.reduce(
      (total, selected) => total + (selected.minimum || 0),
      0
    );
  }

  private _maximum(): number {
    return this._selectedNestedQuotas.reduce(
      (total, selected) => total + (selected.maximum || 0),
      0
    );
  }

  private _fileded(): number {
    return this._selectedNestedQuotas.reduce(
      (total, selected) => total + (selected.fielded || 0),
      0
    );
  }

  private _percentage(): number {
    return this._selectedNestedQuotas.reduce(
      (total, selected) => total + (selected.percentage || 0),
      0
    );
  }

  private _flexibilityPercentage(): number {
    return this._selectedNestedQuotas.reduce(
      (total, selected) => total + (selected.flexiblePer || 0),
      0
    );
  }

  private _quotaTitle(): string {
    return new IncrementalTitleGenerator(this._existingTitles).generateWith(
      'Quota Group'
    );
  }
}
